<template>
    <a :href="href" :title="title" rel="nofollow" class="social-icon-link" :aria-label="ariaLabel">
        <img :src="iconPath" :alt="title" loading="lazy" />
    </a>
</template>

<script setup lang="ts">
interface Props {
    href: string
    title: string
    icon: 'facebook' | 'youtube' | 'linkedin' | 'tiktok'
}

const props = defineProps<Props>()

const iconPath = computed(() => `/leaflypackaging-com/icons/${props.icon}.svg`)

const ariaLabel = computed(() => `Visit our ${props.title} page`)
</script>

<style scoped lang="scss">
.social-icon-link {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    color: #d1d5db;
    transition: color 0.3s ease;

    &:hover {
        color: #ffffff;
    }

    img {
        width: 1.5rem;
        height: 1.5rem;
        transition: transform 0.3s ease;
    }

    &:hover img {
        transform: translateY(-2px);
    }
}

/* TikTok 图标特殊处理 */
.social-icon-link img[src*="tiktok.svg"] {
    filter: brightness(0) invert(1);
}
</style>
